import type { EnglishIqMessagesType } from '../../english-iq-messages-type';

interface IEnglishIqV2StartProps {
  friendResult: { score: number; subBand: string } | null;
  isBusy: boolean;
  messages: EnglishIqMessagesType['v2']['start'];
  onStart: () => void;
}

const filmPerforations = ['one', 'two', 'three', 'four', 'five', 'six'];

export function EnglishIqV2Start({
  friendResult,
  isBusy,
  messages,
  onStart,
}: IEnglishIqV2StartProps): React.JSX.Element {
  const title = friendResult
    ? messages.friendTitle
        .replace('{subBand}', friendResult.subBand)
        .replace('{score}', String(friendResult.score))
    : messages.title;
  return (
    <div className="mx-auto grid min-h-[min(780px,calc(100svh-2rem))] max-w-6xl content-center px-5 py-10 sm:px-8 lg:grid-cols-[1.2fr_0.8fr] lg:gap-16">
      <div className="max-w-3xl">
        <p className="mb-5 text-xs font-bold uppercase tracking-[0.24em] text-[#ff9b50]">
          {friendResult ? messages.friendEyebrow : messages.eyebrow}
        </p>
        <h1 className="text-balance text-5xl font-semibold leading-[0.95] tracking-[-0.05em] text-[#fff8e9] sm:text-7xl lg:text-8xl">
          {title}
        </h1>
        <p className="mt-7 max-w-2xl text-balance text-lg leading-8 text-[#f7edda]/68 sm:text-xl">
          {friendResult ? messages.friendBody : messages.body}
        </p>
        <button
          className="mt-9 min-h-14 rounded-full bg-[#ff7a1a] px-8 text-base font-extrabold text-[#160c06] shadow-[0_12px_45px_rgba(255,122,26,0.28)] transition hover:-translate-y-0.5 hover:bg-[#ff9345] focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#ffb36b] disabled:cursor-wait disabled:opacity-60 motion-reduce:transform-none motion-reduce:transition-none"
          disabled={isBusy}
          onClick={onStart}
          type="button"
        >
          {friendResult ? messages.friendCta : messages.cta}
        </button>
        <p className="mt-4 text-sm text-[#f7edda]/50">{messages.proof}</p>
      </div>
      <div aria-hidden="true" className="relative mt-12 hidden min-h-96 lg:block">
        <div className="absolute inset-0 rotate-3 rounded-[3rem] border border-[#ff7a1a]/25 bg-[radial-gradient(circle_at_30%_20%,rgba(255,122,26,0.26),transparent_40%),linear-gradient(145deg,rgba(255,248,233,0.08),rgba(255,248,233,0.01))] shadow-2xl">
          <div className="absolute inset-x-8 top-8 flex justify-between">
            {filmPerforations.map((perforation) => (
              <span
                className="size-5 rounded-sm border border-[#f7edda]/15 bg-black/40"
                key={perforation}
              />
            ))}
          </div>
          <div className="absolute inset-x-8 bottom-8 flex justify-between">
            {filmPerforations.map((perforation) => (
              <span
                className="size-5 rounded-sm border border-[#f7edda]/15 bg-black/40"
                key={perforation}
              />
            ))}
          </div>
          <div className="absolute inset-16 grid place-items-center rounded-[2rem] bg-black/35 font-mono text-7xl font-black text-[#ff7a1a]">
            IQ
          </div>
        </div>
      </div>
    </div>
  );
}
